import { useDispatch, useSelector } from 'react-redux'
import Image from 'next/image'
import clsx from 'clsx'
import { getFullScreenState } from 'src/redux/selectors'
import { zoomIn, zoomOut, toggleFullScreen } from 'src/redux/actions'
import styles from './styles.module.scss'
import { cancelFullScreen, requestFullScreen } from '../../helpers'
import { ZOOM_IN_MIN, ZOOM_IN_MAX } from '../../helpers'
import ShareButton from 'src/components/ShareButton'
import useWidth from 'src/hooks/useWidth'

export const MapZoomControls = ({ transform, disabled, widget }) => {
  const fullScreen = useSelector(getFullScreenState)
  const dispatch = useDispatch()
  const { isMobile } = useWidth()

  const handleZoomIn = e => {
    e.preventDefault()
    !disabled && dispatch(zoomIn())
  }

  const handleZoomOut = e => {
    e.preventDefault()
    !disabled && dispatch(zoomOut())
  }

  const handleFullscreen = e => {
    e.preventDefault()
    fullScreen ? cancelFullScreen() : requestFullScreen()
    dispatch(toggleFullScreen(!fullScreen))
  }

  if (!transform || widget) {
    return null
  }

  return (
    <div className={styles.zoomControls}>
      <div className={styles.buttonShare}>
        <ShareButton />
      </div>
      {!isMobile && (
        <>
          <div
            className={clsx(styles.zoomIcon, {
              [styles.disabled]: disabled || transform.k >= ZOOM_IN_MAX,
            })}
            onClick={handleZoomIn}
          >
            <Image
              src='/assets/icons/icon-zoom-in.svg'
              width='20'
              height='20'
              alt='Zoom in icon'
            />
          </div>
          <div
            className={clsx(styles.zoomIcon, {
              [styles.disabled]: disabled || transform.k <= ZOOM_IN_MIN,
            })}
            onClick={handleZoomOut}
          >
            <Image
              src='/assets/icons/icon-zoom-out.svg'
              width='20'
              height='20'
              alt='Zoom out icon'
            />
          </div>
        </>
      )}
      <div className={styles.zoomIcon} onClick={handleFullscreen}>
        {fullScreen ? (
          <Image
            src={'/assets/icons/icon-fullscreen-close.svg'}
            width='14'
            height='14'
            alt='Fullscreen icon'
          />
        ) : (
          <Image
            src={'/assets/icons/icon-fullscreen-open.svg'}
            width='14'
            height='14'
            alt='Fullscreen icon'
          />
        )}
      </div>
    </div>
  )
}

export default MapZoomControls
